import { WorkflowLiveStatusBadge } from 'modules/workflows/components/HeaderBar/WorkflowTitle/WorkflowLiveStatusBadge';
import { Link } from 'ui/links';
import { WorkflowType } from 'modules/workflows/enums';
import { TableCell } from './TableCell';
import { WorkflowStatusBadge } from './WorkflowStatusBadge';
import { Workflow } from '../../types';

type WorkflowStatusCellProps = {
  workflow: Workflow;
};

export const WorkflowStatusCell = ({ workflow }: WorkflowStatusCellProps) => {
  const { workflowReference } = workflow;

  return (
    <TableCell data-test="workflow-status-cell">
      {!workflow.isArchived ? (
        <>
          <WorkflowLiveStatusBadge
            isWorkflowEnabled={workflow.enabled}
            workflowType={workflow.workflowType}
          />
          {workflowReference && workflowReference.workflowType === WorkflowType.DRAFT && (
            <Link
              variant="monochrome"
              size="caption"
              href={`/workflows/${workflowReference.id}/edit?workflowType=Draft`}
              data-test="has-draft-link"
            >
              Has draft
            </Link>
          )}
        </>
      ) : (
        <WorkflowStatusBadge workflow={workflow} />
      )}
    </TableCell>
  );
};
